module.exports = __webpack_public_path__ + "static/img/Permiso(13).edc7984.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fotografias/Permiso(13).jpg
// module id = F0iJ
// module chunks = 0